// ── src/data/team.ts ──────────────────────────────────────────
import { TeamMember } from '../types';

const team: TeamMember[] = [
  {
    id: 1,
    name: 'AI Research & Innovation',
    role: 'Machine Learning · NLP · CV',
    avatar: '🧠',
    bio: 'Developing advanced models and filing patents to contribute to the global AI ecosystem.',
  },
  {
    id: 2,
    name: 'Product & Engineering',
    role: 'SaaS Platforms · Automation',
    avatar: '⚙️',
    bio: 'Building AI-powered platforms for healthcare, finance, logistics, and retail at scale.',
  },
  {
    id: 3,
    name: 'Ethical AI & Governance',
    role: 'Responsible AI · Compliance',
    avatar: '🔒',
    bio: 'Ensuring transparency, fairness, and data privacy in every AI application we ship.',
  },
  {
    id: 4,
    name: 'Social Impact & Growth',
    role: 'Partnerships · Talent Dev',
    avatar: '🌱',
    bio: 'Leveraging AI for sustainable agriculture, healthcare access, and AI literacy programs.',
  },
];

export default team;
